import { subWeeks } from 'date-fns'
import setFilters from 'store/reducer-utils/setFilters'
import format from 'utils/dateFns/format'
import { updateObject } from 'utils/updateObject'
import {
  ACCOUNT_SET_FILTER,
  CAMPAIGN_SET_FILTER,
  FILTERS_APPLY,
  SET_FILTER,
} from 'modules/Statistics/types'

const COMMON_FILTER_NAMES = ['date_from', 'date_to', 'include_vat']

const initialState = {
  filters: null,
}

const applyFilters = (state, { payload }) => {
  if (state.filters) {
    return state
  }

  const date_from = payload.find(({ fieldName }) => fieldName === 'date_from')?.value

  const date_to = payload.find(({ fieldName }) => fieldName === 'date_to')?.value

  const now = date_to ? new Date(date_to) : Date.now()

  const startDate = date_from ? new Date(date_from) : subWeeks(now, 2)

  const includeVarParam = payload.find(({ fieldName }) => fieldName === 'include_vat') || true

  return updateObject(state, {
    filters: {
      include_vat: Object.prototype.hasOwnProperty.call(includeVarParam, 'value')
        ? includeVarParam.value
        : true,
      date_group_period: {
        value: payload.find(({ fieldName }) => fieldName === 'date_group_period')?.value || 'day',
        options: ['day', 'week', 'month'],
      },
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(now, 'yyyy-MM-dd'),
    },
  })
}

const setStatisticsFilters = (state, action) => {
  const filteredPayload = [...action.payload].filter(
    (filter) => COMMON_FILTER_NAMES.indexOf(filter.fieldName) > -1,
  )

  return setFilters(state, { ...action, payload: filteredPayload })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTERS_APPLY:
      return applyFilters(state, action)
    case SET_FILTER:
    case ACCOUNT_SET_FILTER:
    case CAMPAIGN_SET_FILTER:
      return setStatisticsFilters(state, action)
    default:
      return state
  }
}

export default reducer
